{
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.closing": [
    {
      "type": 0,
      "value": "Launch your space today to give your team a single, self-service entry point for HR help."
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact": [
    {
      "type": 0,
      "value": "Please "
    },
    {
      "type": 1,
      "value": "contactUsLink"
    },
    {
      "type": 0,
      "value": " with any questions, we're always happy to help."
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact-us-link": [
    {
      "type": 0,
      "value": "contact us"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.cta": [
    {
      "type": 0,
      "value": "Go to your space"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.heading": [
    {
      "type": 0,
      "value": "Bring your HR team together in Jira Service Management"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.intro": [
    {
      "type": 0,
      "value": "You recently started an HR service space, but it looks like your team hasn't moved in yet. When you're ready, Jira Service Management can help you centralize requests and track onboarding in one place."
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.signoff": [
    {
      "type": 0,
      "value": "Cheers,"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-1": [
    {
      "children": [
        {
          "type": 0,
          "value": "Add team members"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " as agents to handle requests"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-2": [
    {
      "children": [
        {
          "type": 0,
          "value": "Set up request types"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " like \"New hire onboarding\""
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-3": [
    {
      "children": [
        {
          "type": 0,
          "value": "Publish your portal"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " so employees can find help"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.steps-heading": [
    {
      "type": 0,
      "value": "Get started in three steps:"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.body.team-name": [
    {
      "type": 0,
      "value": "The Atlassians"
    }
  ],
  "jsm-sherpas.jsm-hr-dormant-project-email.email.subject": [
    {
      "type": 0,
      "value": "Quick check-in on your HR service space"
    }
  ]
}